import { z } from 'zod';

// Mirrors the public API validation for `collection_name` on Backup, BackupSchedule and CollectionAccessRule.
const MAX_COLLECTION_NAME_LENGTH = 255;
const COLLECTION_NAME_PATTERN = /^[a-zA-Z0-9-_.]+$/;

/** A collection name the public API accepts. */
export const collectionNameSchema = z
  .string()
  .trim()
  .min(1, 'Collection name is required')
  .max(MAX_COLLECTION_NAME_LENGTH, `Must be at most ${MAX_COLLECTION_NAME_LENGTH} characters`)
  .regex(COLLECTION_NAME_PATTERN, 'Can only contain letters, numbers, dashes, underscores and dots');
